import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

/** Keeps an error inside a dialog from blanking the whole page. */
export default class DialogErrorBoundary extends React.Component<{ onClose: () => void; children: React.ReactNode }, { message: string }> {
  state = { message: '' };

  static getDerivedStateFromError(error: unknown) {
    return { message: error instanceof Error ? error.message : 'Something went wrong.' };
  }

  componentDidCatch(error: unknown) {
    console.error('Dialog crashed', error);
  }

  render() {
    if (!this.state.message) return this.props.children;
    return <Dialog open onClose={this.props.onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 900 }}>This window could not open</DialogTitle>
      <DialogContent><Alert severity="error">{this.state.message}</Alert></DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}><Button onClick={this.props.onClose}>Close</Button></DialogActions>
    </Dialog>;
  }
}
